import React from 'react';
import { IIconProps } from './utils';

export const Delete = ({ fill = 'currentColor', height = 16, width = 16, ...rest }: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 16 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_3009_418)">
      <path
        d={`M6.66683 3.33325H4.66683C3.93045 3.33325 3.3335 3.93021 3.3335 4.66659V4.99992C3.3335
            5.18401 3.48273 5.33325 3.66683 5.33325H8.66683M6.66683 3.33325V2.66659C6.66683
            1.93021 7.26378 1.33325 8.00016 1.33325C8.73654 1.33325 9.3335 1.93021 9.3335
            2.66659V3.33325M6.66683 3.33325H9.3335M9.3335 3.33325H11.3335C12.0699 3.33325
            12.6668 3.93021 12.6668 4.66659V4.99992C12.6668 5.18401 12.5176 5.33325 12.3335
            5.33325H11.3335M12.0002 7.33325L11.4989 12.8477C11.4052 13.8778 10.5415 14.6666
            9.50707 14.6666H6.49326C5.45885 14.6666 4.59512 13.8778 4.50147 12.8477L4.00016
            7.33325M6.66683 7.33325V12.6666M9.3335 7.33325V12.6666`}
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </g>
    <defs>
      <clipPath id="clip0_3009_418">
        <rect
          fill="white"
          height={height}
          width={width}
        />
      </clipPath>
    </defs>
  </svg>
);
